module.exports = __webpack_public_path__ + "img/2001_S.cdf5fe68.png";